// area.js — startet einen Bereich der neuen Oberfläche (App, Admin, Betreiber):
// Theme, Ripple, adaptives Gerüst, API-Fehlerbehandlung, Router, Seitenwechsel.
import { loginHref, url } from './hosts.js';
import { mountAccount } from '../ui/components/account-menu.js';
import '../ui/index.css';
import { t } from './i18n.js';
import { installRipple } from '../ui/core/ripple.js';
import { installPress, installFabCollapse } from '../ui/core/press.js';
import { installTooltips } from '../ui/components/tooltip.js';
import { initTheme } from '../ui/theme/theme.js';
import { createScaffold } from '../ui/components/shell.js';
import { createRouter } from './router.js';
import { configureApi, api } from './api.js';
import { mountPage } from './page.js';
import { snackbar } from '../ui/components/snackbar.js';
import { registerServiceWorker, installNetworkStatus } from './pwa.js';
import { installErrorBuffer } from './diagnostics.js';
import { LEXICON_PATH } from './knots/lexicon-path.js';

export function areaBase(fallback) {
  // Host-Modus: data-base="" ist gültig (Bereich an der Wurzel seiner Subdomain) — nur ein fehlendes Attribut fällt zurück
  const b = document.documentElement.dataset.base;
  return b != null ? b : fallback;
}

// Brücke für übernommene Module der alten App (src/js/*), die window.tr erwarten
if (typeof window !== 'undefined' && !window.tr) window.tr = (k, v) => t(k, v);

// account: { current, inRail?, loadMe? } — Konto-Knopf in [data-account-slot] (Kopfzeile oder Fuß der Rail)
export function startArea({ base, label, destinations, links, routes, topbar, fab, storageKey, railToggle = true, loginUrl = loginHref, account }) {
  initTheme();
  installErrorBuffer(); // letzte Client-Fehler nur im Speicher — gesendet nur mit Haken im Feedback
  installRipple();
  installPress();
  installFabCollapse();
  installTooltips();
  registerServiceWorker();
  installNetworkStatus();
  const shell = createScaffold(document.getElementById('app'), { label, destinations, links, fab, storageKey, railToggle, accountInRail: !!(account && account.inRail) });
  if (topbar) shell.topbar(topbar);
  configureApi({
    // Das Knoten-Lexikon braucht kein Konto (auch abgemeldet und offline): dort nicht zur Anmeldung springen
    onUnauthorized: () => {
      if (LEXICON_PATH.test(location.pathname)) return;
      location.href = typeof loginUrl === 'function' ? loginUrl() : loginUrl;
    },
    onError: (r) => { if (r.status >= 500 || r.status === 0) snackbar({ text: t('ui.net_error', { msg: r.message || r.code }), error: true, key: 'net' }); },
  });
  const router = createRouter({ base, routes, onChange: (state) => mountPage(state, { shell, router }) });
  router.start();
  if (account) {
    const load = account.loadMe || (() => api.get('/api/me').then((r) => (r.ok ? r.data : null)));
    Promise.resolve(load()).then((me) => {
      // Querverweise mit Voraussetzung (requires = Bereichsschlüssel aus /api/me → areas) erst zeigen, wenn das Konto ihn hat
      const keys = new Set(((me && me.areas) || []).map((a) => a.key));
      for (const el of shell.root.querySelectorAll('[data-requires]')) el.hidden = !keys.has(el.dataset.requires);
      mountAccount(shell.root.querySelector('[data-account-slot]'), { me, current: account.current, profileUrl: url('app', '/profil') });
    }).catch(() => {});
  }
  return { shell, router };
}
